/* eslint-disable */
export default {
  confirmation: 'Vahvistus',
  confirmMergeToConference: 'Lisätäänkö neuvottelupuheluun?',
  mergeToConference: 'Yhdistä',
  conferenceCall: 'Neuvottelupuhelu',
} as const;

// @key: @#@"confirmation"@#@ @source: @#@"Confirmation"@#@
// @key: @#@"confirmMergeToConference"@#@ @source: @#@"Add to conference call?"@#@
// @key: @#@"mergeToConference"@#@ @source: @#@"Merge"@#@
// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
